import lf from 'localforage'
import {get, writable} from 'svelte/store'
import {axiosPost} from '../c0utils'
import {ulid} from 'ulid'

import {User} from './User.js'

export let stApp = writable(App)

export function App() {
    this.user = {
        settings: {
            lang: 'en'
        }
    }
    this.msgs = []
}

App.prototype.load = async function() {
    console.log("in app load")
    const dbApp = await lf.getItem('app')
    if(dbApp) {
        Object.assign(this, dbApp)
        stApp.set(this)
        console.log("App loaded.", get(stApp))
    }
    else console.log("App not found.")
    return this
}

App.prototype.init = async function() {
    const dbApp = await lf.getItem('app')
    if(!dbApp || !dbApp.device_id) {
        this.device_id = ulid()
        lf.setItem('app', this)
        console.log("App initialized.")
    }
    return this
}

App.save = async function() {
    lf.setItem('app', get(stApp))
    console.log("App saved")
}

App.prototype.save_store = async function() {

}
